(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-start/assets/react/components/header.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-start/assets/react/components/header.js');
"use strict";


const Image = svs.content.image_v2.Image;
const _React = React,
  useRef = _React.useRef;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const Button = svs.ui.ReactButton;
const Icon = svs.ui.ReactIcon;
const trackClickPlayLyckoplatsen = svs.lyckoplatsen.page_start.trackClickPlayLyckoplatsen;
const _svs$lyckoplatsen$dat = svs.lyckoplatsen.data.hero,
  heroImage = _svs$lyckoplatsen$dat.heroImage,
  heroGuideLinkColor = _svs$lyckoplatsen$dat.heroGuideLinkColor;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.page_start.react.components,
  MapStart = _svs$lyckoplatsen$com.MapStart,
  HeaderText = _svs$lyckoplatsen$com.HeaderText;
const Header = () => {
  const history = useHistory();
  const headerRef = useRef(null);
  const handlePlayClick = () => {
    trackClickPlayLyckoplatsen(true);
    history.push('/spela');
  };
  const showMap = svs.core.detect.feature('ft-lyckoplatsen-startpage-map');
  const theImage = svs.lyckoplatsen.hooks.useOrientationDetect() === 'landscape' ? heroImage.LANDSCAPE : heroImage.PORTRAIT;
  const handleScrollTo = () => {
    if (headerRef.current) {
      const headerHeight = document.querySelector('header').offsetHeight;
      const targetPos = headerRef.current.getBoundingClientRect().bottom + window.scrollY - headerHeight;
      window.scrollTo({
        top: targetPos,
        behavior: 'smooth'
      });
    }
  };
  return React.createElement("div", {
    className: "lp-page-start-header",
    ref: headerRef
  }, React.createElement("div", {
    className: "lp-page-start-header-content f-content"
  }, !showMap && React.createElement(HeaderText, null), showMap && React.createElement("div", {
    className: "header-result-text-top gsap-result-text-top f-content"
  }, React.createElement("h1", null, "Vinn upp till 1 miljon!"), React.createElement("h4", null, "3 vinstchanser varje vecka f\xF6r 40 kr")), React.createElement(Button, {
    className: "lp-green header-choose-btn gsap-choose-btn",
    onClick: handlePlayClick,
    size: 300
  }, "Spela Lyckoplatsen"), React.createElement("div", {
    className: "lp-guide-button gsap-guide-button",
    type: "button",
    onClick: handleScrollTo
  }, React.createElement("p", {
    style: heroGuideLinkColor === 'fc-white' ? {
      color: 'white'
    } : undefined
  }, "S\xE5 funkar Lyckoplatsen"), React.createElement(Icon, {
    size: "600",
    color: heroGuideLinkColor,
    icon: "menu-down"
  }))), showMap && React.createElement(MapStart, null), !showMap && React.createElement(Image, {
    cssSelectors: "lp-hero-multi-image background-image-wrapper image-wrapper-fit",
    image: theImage
  }));
};
setGlobal('svs.lyckoplatsen.components.page_start.react.components', {
  Header
});

 })(window);